module.exports = __webpack_public_path__ + "img/plus.eff247b0.svg";